/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_Page_First_TitleInputs */

const en_start_page_first_title = /** @type {(inputs: Start_Page_First_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bookings come in on their own.`)
};

const pl_start_page_first_title = /** @type {(inputs: Start_Page_First_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezerwacje wpadają same.`)
};

/**
* | output |
* | --- |
* | "Bookings come in on their own." |
*
* @param {Start_Page_First_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const start_page_first_title = /** @type {((inputs?: Start_Page_First_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_Page_First_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_start_page_first_title(inputs)
	return en_start_page_first_title(inputs)
});